import { useParams } from "react-router";
import _ from "lodash";

import { URLS } from "config/urls";
import { reverse } from "utils/urls";

import { MenuItem } from "components/Menu";
import NavLink from "components/NavLink";

import type { IDealPackage } from "entities/Package/sdk";

export interface IPackageLink {
  companyPackage: IDealPackage;
  isSelected: boolean;
}

const PackageLink = ({ companyPackage, isSelected }: IPackageLink) => {
  const params = useParams<{
    dealId: string;
  }>();

  const dealId = Number(params.dealId);

  return (
    <NavLink
      linkDataTestid="deal-checklist-link"
      to={reverse(URLS.DEAL_PACKAGE_NO_TAB, {
        dealId,
        packageId: companyPackage.package_id,
      })}
    >
      <MenuItem
        selected={isSelected}
        data-testid="checklist-package-name"
        title={companyPackage.name}
      >
        {_.truncate(companyPackage.name, { length: 24 })}
      </MenuItem>
    </NavLink>
  );
};

export default PackageLink;
